var _circle, _path, _rect, _rect2, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgButtonMove(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "ui-button circle-button change-button move-button",
    width: "100%",
    height: "100%",
    viewBox: "0 0 125 125",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "interior-background",
    cx: 62.5,
    cy: 62.5,
    r: 62.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.5,-0.025c34.495,0 62.5,28.006 62.5,62.5c0,34.495 -28.005,62.5 -62.5,62.5c-34.495,0 -62.5,-28.005 -62.5,-62.5c0,-34.494 28.005,-62.5 62.5,-62.5Zm0,16.667c25.296,0 45.833,20.537 45.833,45.833c0,25.297 -20.537,45.834 -45.833,45.834c-25.296,-0 -45.833,-20.537 -45.833,-45.834c-0,-25.296 20.537,-45.833 45.833,-45.833Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 58.333,
    y: 33.333,
    width: 8.333,
    height: 58.333
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 58.333,
    y: 33.333,
    width: 8.333,
    height: 58.333
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.333,58.309l0,8.333l58.334,0l-0,-8.333l-58.334,-0Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.333,58.309l0,8.333l58.334,0l-0,-8.333l-58.334,-0Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5,25l8.333,16.667l-16.666,-0l8.333,-16.667Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5,100l-8.333,-16.667l16.666,0l-8.333,16.667Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25,62.5l16.667,-8.333l-0,16.666l-16.667,-8.333Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M100,62.5l-16.667,8.333l0,-16.666l16.667,8.333Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonMove);
export default __webpack_public_path__ + "static/media/button-move.63e59e08.svg";
export { ForwardRef as ReactComponent };